export default __webpack_public_path__ + "static/media/flow_resize.ae100ef5.svg";